define('models/composer/Template',[
    'lib/knockout',
    'util/ObservableModel'
], function (
    ko,
    ObservableModel
) {
    'use strict';

    var TemplateModel = ObservableModel.extend({
        defaults: {

        }
    }, function _init(
            data
        ) {
        var self = this;

        if(data.data) {
            //Don't wrap all of the data's properties into observables
            self.data(data.data);
        }

        self.unwrap = function () {
            var ignore = [ // default ignored properties
                "createdDate",
                "modifiedDate",
                "unwrap"
            ];
            return ObservableModel.unwrap(self, ignore);
        };
    });

    return TemplateModel;
});

